export default __webpack_public_path__ + "static/media/42_bang_arang.ce7674af.png";